export enum ColorMode {
  LIGHT = 'light',
  DARK = 'dark',
}

export const DEFAULT_COLOR_MODE = ColorMode.LIGHT;

export const COLOR_MODE_COOKIE_NAME = 'color-mode';
